const MENTEE_MODULE_TYPES = {
  elective: 'elective',
  mandatory: 'mandatory',
};

const CORE_MENTEE_MODULE_STATUSES = [
  MENTEE_MODULE_TYPES.elective,
  MENTEE_MODULE_TYPES.mandatory,
];

export const SUPER_BATCH_MODULE_TYPE_OPTIONS = Object.values(
  MENTEE_MODULE_TYPES
)
  .filter((status) => CORE_MENTEE_MODULE_STATUSES.includes(status))
  .map((status) => ({
    label: status,
    value: status,
  }));
